import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'baf-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin.component.ts